import { render, staticRenderFns } from "./orgGroupList.vue?vue&type=template&id=8fbf39ac"
import script from "./orgGroupList.vue?vue&type=script&lang=js"
export * from "./orgGroupList.vue?vue&type=script&lang=js"
import style0 from "./orgGroupList.vue?vue&type=style&index=0&id=8fbf39ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports